<div *ngIf="role && role.id"
      (click)="showList = false; $event.stopPropagation();"
      class="listContainer">
      <div *ngIf="showList" (click)="showList = !showList;" class="list-overlay-close"></div>
    <div class="list-title" [ngClass]="{'field-required' : mandatory}">
        <span class="title">
            {{ 'reg.institution' | translate }}
        </span>
    </div>
    <div class="row p-0 m-0 page-table expanded-list">
            <div class="list-group-collapse duo flex-wrap list-item-container">
                <ng-container *ngFor="let roleInstitution of roleInstitutions; let i=index;">
                    <div *ngIf="roleInstitution.id" class="duo {{i === 0 ? 'first' : ''}} item list-item">
                        <div class="d-flex justify-content-between col">
                            <div class="d-flex align-items-center w-100"
                                (click)="openEdit(roleInstitution);$event.stopPropagation();">
                                <span>{{roleInstitution.institutionName}}</span>
                            </div>
                            <div class="d-flex align-items-center">
                                <confirmation [showTrashIcon]="true"
                                            [question]="'confirm.areyousure'"
                                            [extraClasses]="'d-flex'"
                                            (click)="$event.stopPropagation()"
                                            (isConfirmed)="deleteRoleInstitution($event, roleInstitution.id, i)"></confirmation>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <drawer-items class="mt-1"
                [items]="institutions"
                [title]="'reg.institution'"
                (itemSelected)="addRoleInstitution($event)"
                [openListButtonLabel]="'Select or add new'"
                [showAddButton]="true"
                (askForNew)="openEdit(false, $event)"></drawer-items>
    </div>
</div>
